module.exports = __webpack_public_path__ + "media/common/images/cta/claire-bed8d08ca54e52f2003da5ce7a4ae543.jpeg";